import {
    Component,
    EventEmitter,
    Input,
    Output,
    HostBinding,
    ChangeDetectionStrategy,
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { AlertMessage } from '../../../core/services/alert/models/alert-message';
import {
    AlertSeverityCardClassMapping,
    AlertSeverityLabelMapping,
    AlertSeverityTextClassMapping,
} from '../../../core/constants/alert-severity-enum';
import { CommonModule } from '@angular/common';
import {
    SlideInOutAnimation,
    SlideInOutAnimationName,
    SlideInOutAnimationTag,
} from './animations/animations';

@Component({
    selector: 'app-alert-card',
    templateUrl: './alert-card.component.html',
    imports: [MatCardModule, MatIconModule, CommonModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    animations: [SlideInOutAnimation],
})
export class AlertCardComponent {
    readonly slideInOutAnimationName = SlideInOutAnimationName;

    @Input() alert!: AlertMessage;
    @Output() removeAlert = new EventEmitter<string>();
    @HostBinding(SlideInOutAnimationTag) animationState = true;

    closeAlert(): void {
        this.animationState = false;
        this.removeAlert.emit(this.alert.id);
    }

    getSeverityTextClass(): string {
        return AlertSeverityTextClassMapping[this.alert.severity];
    }

    getSeverityCardClass(): string {
        return AlertSeverityCardClassMapping[this.alert.severity];
    }

    getAlertLabel(): string {
        return AlertSeverityLabelMapping[this.alert.severity];
    }
}
